import { server } from '../constants';
import { httpClient } from './../utils/HttpClient';

// Dimension data model

/**
 * getListAll(), get list all of dimension
 * Method: GET
 * @returns
 */
export function getListAll(params = { lang: 'TH' }) {
  return httpClient
    .get(`${server.ISSUE_URL}/getDimensionList/${params.lang}`)
    .then((result) => {
      return result.data.content;
    })
    .catch((error) => {
      throw error;
    });
}
